module.exports = (app) => {
  require('../../radio/common')(app);
  require('./analytics')(app);
  require('./pros-factory')(app);
  require('@feature/account-notifications').radio(app);
  require('./delayedScripts')(app);
};
